import { useEffect, useState } from "react";
import { Alert, Flex, Grid, Tabs, useMantineTheme } from "@mantine/core";
import { aulaService } from "../../api";
import { TActiveEnrollment, TPreviousEnrollment } from "../../types/Aula";
import { EnrollmentCard } from "../EnrollmentCard";
import { EducacionTabs } from "../Educacion";
import { useAuth } from "../../context";
import { GenderLabLoader } from "../GenderLabLoader";
import { IconInfoCircle } from "@tabler/icons";

export const AulaInicio = () => {
  const { user } = useAuth();
  const [activeEnrollments, setActiveEnrollments] = useState<
    TActiveEnrollment[]
  >(null!);
  const [previousEnrollments, setPreviousEnrollments] = useState<
    TPreviousEnrollment[]
  >(null!);
  const theme = useMantineTheme();
  const [activeTab, setActiveTab] = useState<string | null>("activos");
  const selectedTabStyle = (tabName: string) => ({
    backgroundColor: activeTab === tabName ? theme.colors.dark[7] : "#d4d4d4",
    color: activeTab === tabName ? theme.white : theme.colors.gray[9],
  });

  useEffect(() => {
    fetchEnrollmentData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const fetchEnrollmentData = async () => {
    try {
      const activeEnrollmentsResponse =
        await aulaService.getActiveEnrollments();
      setActiveEnrollments(activeEnrollmentsResponse.data.enrollments);
      const previousEnrollmentsResponse =
        await aulaService.getPreviousEnrollments();
      setPreviousEnrollments(previousEnrollmentsResponse.data.enrollments);
    } catch (error: any) {
      setActiveEnrollments([]);
      setPreviousEnrollments([]);
    }
  };

  const customAlert = (title: string, message: any, color: string, icon: any) => (
    <Flex ta="center" justify="center">
      <Alert
        variant="light"
        mt="md"
        w="50%"
        color={color}
        title={title}
        ta="justify"
        icon={icon}
      >
        {message}
      </Alert>
    </Flex>
  );

  if (!user || !activeEnrollments || !previousEnrollments) {
    return <GenderLabLoader />;
  }

  // const ctaText = user.hasExpiredAULA ? "renovarlo" : "contratarlo";
  // {user.hasAULA === false && (
  //   customAlert(
  //     "No tienes permiso de aula virtual",
  //     <>
  //       Para {ctaText},{" "}
  //       <CustomLink to={contactURL} target="_blank">
  //         contáctanos
  //       </CustomLink>
  //     </>,
  //     "red",
  //     <IconAlertCircle />
  //   )
  // )}

  return (
    <EducacionTabs defaultValue="activos" value={activeTab} onChange={setActiveTab}>
      <Tabs.List>
        <Tabs.Tab value="activos" style={selectedTabStyle("activos")}>
          Activos
        </Tabs.Tab>
        <Tabs.Tab value="anteriores" style={selectedTabStyle("anteriores")}>
          Anteriores
        </Tabs.Tab>
      </Tabs.List>
      <Tabs.Panel value="activos" pt="sm">
        {activeEnrollments.length > 0 ? (
          <Grid>
            {activeEnrollments.map((enrollment) => (
              <Grid.Col key={enrollment.course.id} span={{ sm: 6, lg: 4 }}>
                <EnrollmentCard enrollment={enrollment} category="active" />
              </Grid.Col>
            ))}
          </Grid>
        ) : (
          customAlert("Cursos activos", "No tienes cursos activos en este momento.", "blue", <IconInfoCircle />)
        )}
      </Tabs.Panel>
      <Tabs.Panel value="anteriores" pt="sm">
        {previousEnrollments.length > 0 ? (
          <Grid>
            {previousEnrollments.map((enrollment) => (
              <Grid.Col key={enrollment.course.id} span={{ sm: 6, lg: 4 }}>
                <EnrollmentCard enrollment={enrollment} category="previous" />
              </Grid.Col>
            ))}
          </Grid>
        ) : (
          customAlert("Cursos anteriores", "No tienes cursos anteriores en este momento.", "blue", <IconInfoCircle />)
        )}
      </Tabs.Panel>
    </EducacionTabs>
  );
};
